import React, { useState } from 'react';
import { useAppData } from '../../components/AppDataProvider';
import { isDataLoaded } from '../../types/data-providers';
import { SELECTED_ORGANIZATION } from '../../constants';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';

type Organization = { id: string; name: string };
export type ContextState = {
    organizationList: Organization[];
    selectedOrganization: string;
    updateSelectedOrganization: (organizationId: string) => void;
};
const Context = React.createContext<ContextState | null>(null);

function useOrganizationList(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useOrganizationList must be used within a OrganizationListProvider');
    }

    return contextState;
}
const OrganizationListProvider: React.FC = (props) => {
    const appData = useAppData();
    const [selectedOrganization, setSelectedOrganization] = useState('');
    const currentAppRoute = useCurrentAppRoute();
    const updateSelectedOrganization = (organizationId: string): void => {
        window.localStorage.setItem(SELECTED_ORGANIZATION, organizationId);
        setSelectedOrganization(organizationId);
    };
    let organizationList;
    organizationList = {
        organizationList: [],
        selectedOrganization: '',
        updateSelectedOrganization: updateSelectedOrganization,
    };
    if (isDataLoaded(appData) && appData.value.organizations.ok) {
        const emptyOrganizations: Organization[] = [];
        const organizations = Object.values(appData.value.organizations.value).reduce((memo, org, i) => {
            memo[i] = {
                id: Object.values(org)[1].id,
                name: Object.values(org)[1].name,
            };
            return memo;
        }, emptyOrganizations);

        if (selectedOrganization === '' && organizations.length > 0) {
            const value =
                'orgId' in currentAppRoute ? currentAppRoute.orgId : window.localStorage.getItem(SELECTED_ORGANIZATION);

            setSelectedOrganization(value ? value : organizations[0].id);
        }
        organizationList = {
            organizationList: organizations,
            selectedOrganization: selectedOrganization,
            updateSelectedOrganization: updateSelectedOrganization,
        };
    }

    return <Context.Provider value={organizationList}>{props.children}</Context.Provider>;
};

export { OrganizationListProvider, useOrganizationList };
